import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CategoryColors } from '@jessie/commons';

@Component({
  selector: 'app-category-badge',
  templateUrl: './category-badge.component.html',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @reference "tailwindcss";
    :host {
      @apply select-none;
    }
  `,
})
export class CategoryBadgeComponent {
  @Input()
  color: CategoryColors = 'grey';
  @Input()
  displayName: string = '';
}
